// extracted by mini-css-extract-plugin
module.exports = {"border":"Header-module--border--1_Tbh","shadow":"Header-module--shadow--1mkJt"};